import { createApi,fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { Base_url } from "../../utils/utils";


export const companyApi = createApi({
    reducerPath: "companyApi",
    baseQuery: fetchBaseQuery({ baseUrl: Base_url }),
    endpoints: (builder) => ({
        getCompanyColumn: builder.query({
            query: () => `/company/columns`,
        }),
        getCompanyCategory: builder.query({
            query: () => `/company/company-categories`,
        }),
        getFilterCompany: builder.query({
            query: (category) => `/company/companies/?category=${category}`,
        }),
        getCompanies: builder.query({
            query: (pageNo) => `/company/companies/?page=${pageNo}`,
        }),
        getCompaniesSearch: builder.query({
            query: ({ inp,currentPage }) => `/company/companies/?search=${inp}&page=${currentPage}`,
        }),
        getCompaniesTrending: builder.query({
            query: (pageNo) => `/blogs/blog-view/?page=${pageNo}`,
        }),
        getCompaniesMore: builder.query({
            query: (pageNo) => `/blogs/blog-view/?page=${pageNo}`,
        }),     
    }),
});


export const {
    useGetCompanyColumnQuery,
    useGetCompaniesQuery,
    useGetCompanyCategoryQuery,
    useGetCompaniesSearchQuery,
    useGetFilterCompanyQuery,
    useGetCompaniesTrendingQuery,
    useGetCompaniesMoreQuery
} = companyApi;